/**
 * reportReservedInstance模块接口列表
 */
import $http from '../utils/http'; // 导入http中创建的axios实例

const reportReservedInstance = {
  //添加预留实例和花费对比
  createReportReservedInstance(params) {
    return $http.post(`${global.API_URL}/sme/reportReservedInstance/createReportReservedInstance`,params);
  },
  //删除预留实例和花费对比
  deleteReportReservedInstance(id ,params) {
    let param = new URLSearchParams();
    param.append(id, params);
    return $http.post(`${global.API_URL}/sme/reportReservedInstance/deleteReportReservedInstance`,param);
  },
  //获取月度账务分析结果
  getMonthlyBillingAnalysis(params) {
    return $http.post(`${global.API_URL}/sme/reportReservedInstance/getMonthlyBillingAnalysis`,params);
  },
  //查询预留实例匹配结果
  getReservedInstanceMatchingResult(params) {
    return $http.post(`${global.API_URL}/sme/reportReservedInstance/getReservedInstanceMatchingResult`,params);
  },
  //查询购买预留实例前后花费对比
  getReservedInstanceRecommendedCostComparisons(params) {
    return $http.post(`${global.API_URL}/sme/reportReservedInstance/getReservedInstanceRecommendedCostComparisons`,params);
  },
  //预留实例和花费对比查询
  listReportReservedInstances(params) {
    return $http.post(`${global.API_URL}/sme/reportReservedInstance/listReportReservedInstances`,params);
  }
}

export default reportReservedInstance;



// WEBPACK FOOTER //
// ./src/api/reportReservedInstance.js